import tradingVenuesStore from './TradingVenuesStore';
import userStore from './UserStore';
import dataSelectStore from './DataSelectStore';
import executionReportingStore from './ExecutionReportingStore'
import orderStore from './OrderStore';
import settingsStore from './SettingsStore';
import documentationStore from './DocumentationStore';
import parameters from './Parameters';

export default {
  tradingVenuesStore,
  userStore,
  dataSelectStore,
  orderStore,
  settingsStore,
  executionReportingStore,
  documentationStore,
  parameters
};



// WEBPACK FOOTER //
// ./src/stores/index.js